export const koKR_avatorDropMenu = {
  'header.avator.account': '계정',
  'header.avator.logout': '로그 아웃',
  'global.theme.switchTheme': '테마 전환',
  'global.theme.switchingTheme': '테마 전환 중...',
  'global.theme.switchThemeDone': '성공적으로 테마 업데이트!',
  'global.theme.switchThemeFail': '테마 업데이트 실패'
};
